(function () {
  'use strict';

  var config = window.__ALGOLIA_CONFIG;
  if (!config || !config.appId || config.appId.indexOf('REPLACE') === 0) {
    console.warn('[Algolia] Search credentials not configured. Autocomplete disabled.');
    return;
  }
  var isPathSearch = window.location.pathname.startsWith('/search');

  var PLACEHOLDER_IMAGE = (function () {
    var src = (document.currentScript && document.currentScript.src) || '';
    return src.replace(/algolia-autocomplete\.js.*$/, 'default-magnolia.jpg');
  })();

  var RECENT_KEY = 'magnolia_recent_searches';
  var MAX_RECENT = 5;

  // Guards against re-publishing "searchOpen" when .aa-Input regains focus
  // as a side effect of clearing the query rather than a genuine user
  // "open search" action. This has to live at the very top of the script and
  // be registered on `document` (capture phase) *before* initAutocomplete()
  // ever runs — i.e. before the real Autocomplete library gets a chance to
  // attach any listener of its own. Capture-phase order is determined by
  // DOM position (document is visited before any container or the button
  // itself), so a document-level listener registered here always sees the
  // interaction first, regardless of what the library does internally or
  // which event (click/mousedown/reset) it uses.
  var suppressNextOpenAnalytics = false;
  var suppressNextOpenAnalyticsTimer = null;

  function armSuppressNextOpenAnalytics() {
    suppressNextOpenAnalytics = true;
    if (suppressNextOpenAnalyticsTimer) clearTimeout(suppressNextOpenAnalyticsTimer);
    suppressNextOpenAnalyticsTimer = setTimeout(function () {
      suppressNextOpenAnalytics = false;
      suppressNextOpenAnalyticsTimer = null;
    }, 400);
  }

  function isClearButtonTarget(e) {
    return !!(e.target && e.target.closest && e.target.closest('.aa-ClearButton'));
  }

  document.addEventListener(
    'mousedown',
    function (e) {
      if (isClearButtonTarget(e)) armSuppressNextOpenAnalytics();
    },
    true,
  );
  document.addEventListener(
    'click',
    function (e) {
      if (isClearButtonTarget(e)) armSuppressNextOpenAnalytics();
    },
    true,
  );

  /**
   * Publish click analytics event
   * @param {string} moduleName - Analytics module name (e.g., 'navigation:searchBar:autocomplete:product')
   * @param {string} linkTitle - Link title (e.g., product name, article title)
   * @param {string} linkText - Link text token (e.g., 'link', 'searchOpen', 'dismiss')
   * @param {string} targetURL - Destination URL (optional, for Path B events)
   */
  function publishClickEvent(moduleName, linkTitle, linkText, targetURL) {
    if (!window.Shopify || !window.Shopify.analytics || !window.Shopify.analytics.publish) {
      return;
    }

    var clickData = {
      moduleName: moduleName,
      linkTitle: linkTitle || '',
      linkText: linkText || '',
      targetURL: targetURL || null,
      locURL: window.location.href,
    };

    try {
      // Wrapped in { clickData } to match the shape the AEP pixel's
      // page-click subscriber expects (event.customData.clickData) —
      // same convention used by theme.liquid's generic click tracker.
      window.Shopify.analytics.publish('page-click', { clickData: clickData });
    } catch (error) {
      console.error('[Algolia Analytics] Failed to publish click event:', error);
    }
  }

  function getStorage() {
    try {
      var test = '_ac_storage_test';
      localStorage.setItem(test, '1');
      localStorage.removeItem(test);
      return localStorage;
    } catch {
      return sessionStorage;
    }
  }

  var storage = getStorage();

  function getRecentSearches() {
    try {
      return JSON.parse(storage.getItem(RECENT_KEY)) || [];
    } catch {
      return [];
    }
  }

  function saveRecentSearch(query) {
    if (!query || !query.trim()) return;
    var recent = getRecentSearches().filter(function (r) {
      return r !== query;
    });
    recent.unshift(query);
    if (recent.length > MAX_RECENT) recent = recent.slice(0, MAX_RECENT);
    storage.setItem(RECENT_KEY, JSON.stringify(recent));
  }

  function removeRecentSearch(query) {
    var recent = getRecentSearches().filter(function (r) {
      return r !== query;
    });
    storage.setItem(RECENT_KEY, JSON.stringify(recent));
  }

  function formatPrice(price) {
    return '$' + parseFloat(price).toFixed(2);
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  // Populated from Algolia's Query Suggestions index (see loadPopularSearches
  // in initAutocomplete) — that index is built by Algolia from real search
  // analytics, so an empty-query lookup against it returns the current
  // top/trending queries instead of a list we'd have to maintain by hand.
  // Used until the live fetch resolves, and kept if it comes back empty or
  // fails (offline, index not yet built on a fresh site, etc.) so the panel
  // never just shows a gap where popular searches should be.
  var POPULAR_SEARCHES_FALLBACK = ['Coffee Table', 'Table Lamps', 'Bedding', 'Rugs', 'Sofas'];
  var POPULAR_SEARCHES = POPULAR_SEARCHES_FALLBACK;
  var defaultStateRepainters = [];

  var SVG_CLOCK =
    '<svg class="ac-Icon" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.3"><circle cx="8" cy="8" r="6.4"/><path d="M8 4.6V8.2L10.4 9.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var SVG_SEARCH =
    '<svg class="ac-Icon ac-Icon--muted" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><circle cx="11" cy="11" r="7"/><line x1="16.2" y1="16.2" x2="21" y2="21" stroke-linecap="round"/></svg>';
  var SVG_ARROW =
    '<svg class="ac-Icon ac-Icon--arrow" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M3 8H13M13 8L9 4M13 8L9 12"/></svg>';
  var SVG_CLOSE =
    '<svg class="ac-Icon" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"><path d="M2 2L12 12M12 2L2 12"/></svg>';
  var SVG_TRENDING =
    '<svg class="ac-Icon ac-Icon--trending" viewBox="0 0 14 8" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><path d="M1 7L5.2 2.8L7.8 5.4L13 0.2"/><path d="M9.4 0.2H13V3.8"/></svg>';

  function initAutocomplete() {
    var containers = document.querySelectorAll('[data-algolia-autocomplete]');
    if (!containers.length) return;

    var acLib = window['@algolia/autocomplete-js'];
    var algoliaLib = window['algoliasearch/lite'];
    if (!algoliaLib || !acLib) {
      console.warn('[Algolia] Libraries not loaded. Check CDN scripts.');
      return;
    }

    var searchClient = algoliaLib.liteClient(config.appId, config.searchOnlyApiKey);
    var autocompleteFn = acLib.autocomplete;

    function loadPopularSearches() {
      var queryContentIndex = config.indices && config.indices.queryContent;
      if (!queryContentIndex) return;

      searchClient
        .search([
          {
            indexName: queryContentIndex,
            query: '',
            params: { hitsPerPage: 20, attributesToRetrieve: ['query', 'popularity'] },
          },
        ])
        .then(function (res) {
          var hits = (res.results[0] && res.results[0].hits) || [];
          var terms = hits
            .map(function (hit) {
              return hit;
            })
            .filter(function (hit) {
              return (hit.popularity || 0) >= MIN_POPULAR_POPULARITY;
            })
            .map(function (hit) {
              return hit.query;
            })
            .filter(Boolean)
            .slice(0, 5);

          POPULAR_SEARCHES = terms.length > 0 ? terms : POPULAR_SEARCHES_FALLBACK;
          defaultStateRepainters.forEach(function (repaint) {
            repaint();
          });
        })
        .catch(function (err) {
          console.error('[Algolia] Popular searches fetch failed:', err);
        });
    }

    var MIN_POPULAR_POPULARITY =
      typeof config.popularSearchesMinPopularity === 'number' ? config.popularSearchesMinPopularity : 5;

    if (config.enableDynamicPopularSearches !== false) {
      loadPopularSearches();
    }

    var scrim = document.createElement('div');
    scrim.className = 'ac-Scrim';
    scrim.addEventListener('click', function () {
      if (!activeContainer) return;
      var inp = activeContainer.querySelector('.aa-Input');
      if (inp) {
        if (!isPathSearch) {
          inp.value = '';
        }
        inp.dispatchEvent(new Event('input', { bubbles: true }));
        inp.blur();
      }
      closeSearch();
    });
    document.body.appendChild(scrim);

    function showScrim() {
      var headerBottom = topBar ? topBar.getBoundingClientRect().bottom : 0;
      scrim.style.clipPath = 'inset(' + headerBottom + 'px 0 0 0)';
      scrim.classList.add('ac-Scrim--visible');
      document.body.classList.add('ac-overflow-hidden');
      document.body.style.overscrollBehavior = 'none';
    }

    function hideScrim() {
      scrim.style.clipPath = '';
      scrim.classList.remove('ac-Scrim--visible');
      document.body.classList.remove('ac-overflow-hidden');
      document.body.style.overscrollBehavior = '';
    }

    var topBar = document.querySelector('.header-top-bar');
    var announcementWrapper = document.querySelector('.header-announcement-wrapper');
    var mobileOverlay = document.getElementById('ac-mobile-overlay');

    if (mobileOverlay && mobileOverlay.parentElement !== document.body) {
      document.body.appendChild(mobileOverlay);
    }
    var mobileSearchTrigger = document.querySelector('.header-search-trigger');

    var activeContainer = null;

    function setInlineActive(container, isActive) {
      if (!container) return;
      container.classList.toggle('ac-InlineActive', isActive);
      var wrapper = container.closest('.template-search__search');
      if (wrapper) wrapper.classList.toggle('ac-InlineActive', isActive);
      var page = container.closest('.template-search');
      if (page) page.classList.toggle('ac-InlineActive', isActive);
    }

    function openSearch(container) {
      // "searchOpen" must only represent a genuine closed->open transition.
      // Any refocus that happens while this container is already the active
      // one — whatever causes it (our own code, the library's internal
      // clear-button handling, or the click-anywhere-in-.aa-Form convenience
      // refocus below) — is not a new "open" and must not re-publish.
      var wasAlreadyOpen = !!container && activeContainer === container;

      // suppressNextOpenAnalytics / its timer live at module scope (top of
      // this file) so the document-level capture listeners registered there
      // can arm the guard before this function — or this whole container —
      // even exists. Kept as a second, independent guard for the specific
      // case where the container wasn't open yet but the refocus is still a
      // known side effect of clearing (e.g. clicking Clear on a freshly
      // loaded page before ever focusing the input).
      var skipAnalytics = wasAlreadyOpen || suppressNextOpenAnalytics;
      suppressNextOpenAnalytics = false;
      if (suppressNextOpenAnalyticsTimer) {
        clearTimeout(suppressNextOpenAnalyticsTimer);
        suppressNextOpenAnalyticsTimer = null;
      }

      activeContainer = container || null;
      setInlineActive(container, true);

      if (!skipAnalytics) {
        publishClickEvent('navigation:searchBar', 'searchOpen', 'searchOpen', null);
      }

      var isMobile = container && container.getAttribute('data-mobile') === 'true';
      if (isMobile) {
        if (mobileOverlay) mobileOverlay.hidden = false;
        document.body.classList.add('ac-overflow-hidden');
        document.body.style.overscrollBehavior = 'none';
        var openInput = container.querySelector('.aa-Input');
        if (openInput) {
          openInput.setAttribute('role', 'combobox');
          openInput.setAttribute('aria-expanded', 'true');
        }
      } else {
        showScrim();
        if (topBar) topBar.classList.add('search-active');
        if (announcementWrapper) announcementWrapper.classList.add('ac-search-open');
      }
    }

    function closeSearch(suppressAnalytics) {
      // Publish searchClose event (P0) - suppressAnalytics allows Clear flow to skip this
      if (activeContainer && !suppressAnalytics) {
        publishClickEvent('navigation:searchBar', 'searchClose', 'searchClose', null);
      }

      setInlineActive(activeContainer, false);
      activeContainer = null;
      hideScrim();
      if (topBar) topBar.classList.remove('search-active');
      if (announcementWrapper) announcementWrapper.classList.remove('ac-search-open');
      if (mobileOverlay && !mobileOverlay.hidden) {
        mobileOverlay.hidden = true;
        var mobileInput = mobileOverlay.querySelector('.aa-Input');
        if (mobileInput) {
          if (!isPathSearch) {
            mobileInput.value = '';
          }
          mobileInput.dispatchEvent(new Event('input', { bubbles: true }));
          mobileInput.setAttribute('aria-expanded', 'false');
        }
        if (mobileSearchTrigger) {
          mobileSearchTrigger.setAttribute('aria-expanded', 'false');
          mobileSearchTrigger.focus();
        }
      }
      document.body.classList.remove('ac-overflow-hidden');
      document.body.style.overscrollBehavior = '';
    }

    document.addEventListener(
      'keydown',
      function (e) {
        if (e.key !== 'Escape' || !activeContainer) return;
        var inp = activeContainer.querySelector('.aa-Input');
        if (inp) inp.blur();
        closeSearch();
      },
      { capture: true },
    );

    document.addEventListener('click', function (e) {
      if (!activeContainer) return;

      if (activeContainer.contains(e.target)) return;

      if (scrim.contains(e.target)) return;

      var inp = activeContainer.querySelector('.aa-Input');
      if (inp) {
        if (!isPathSearch) {
          inp.value = '';
        }
        inp.dispatchEvent(new Event('input', { bubbles: true }));
        inp.blur();
      }
      closeSearch();
    });

    containers.forEach(function (container) {
      var cachedHits = {};
      var cachedCounts = {};
      var currentQuery = '';

      var latestRequestId = 0;
      var resolvedRequestId = 0;
      var pendingSourceCount = 0;
      var requestStartedAt = 0;
      var isLoading = false;

      var MIN_SKELETON_MS = 400;
      var lastPaintedState = null;
      var lastPaintedRoot = null;

      function finishRequest(requestId) {
        var elapsed = Date.now() - requestStartedAt;
        var remaining = MIN_SKELETON_MS - elapsed;
        if (remaining <= 0) {
          resolvedRequestId = requestId;
          isLoading = false;
          repaint();
        } else {
          setTimeout(function () {
            if (requestId === latestRequestId) {
              resolvedRequestId = requestId;
              isLoading = false;
              repaint();
            }
          }, remaining);
        }
      }

      function repaint() {
        if (lastPaintedRoot) {
          renderPanel(lastPaintedState, lastPaintedRoot);
        }
      }

      defaultStateRepainters.push(repaint);

      // Live region for screen reader announcements
      var liveRegion = document.createElement('div');
      liveRegion.setAttribute('role', 'status');
      liveRegion.setAttribute('aria-live', 'polite');
      liveRegion.setAttribute('aria-atomic', 'true');
      liveRegion.className = 'ac-SROnly';
      container.appendChild(liveRegion);

      var panelAnchor = container.closest('.header-top-bar') || container.parentElement;
      function syncPanelLeft() {
        if (!panelAnchor) return;
        var offset = container.getBoundingClientRect().left - panelAnchor.getBoundingClientRect().left;
        container.style.setProperty('--ac-panel-left', offset + 'px');
      }
      syncPanelLeft();
      window.addEventListener('resize', syncPanelLeft);

      var MAX_VISIBLE_PRODUCTS_DESKTOP = 5;
      var MAX_VISIBLE_PRODUCTS_MOBILE = 4;
      var mobileMql = window.matchMedia('(max-width: 989px)');

      var productCountMql = window.matchMedia('(max-width: 767px)');
      var lastProductsRoot = null;

      var explicitProductLimit = parseInt(container.getAttribute('data-product-limit'), 10);
      function getMaxVisibleProducts() {
        if (!isNaN(explicitProductLimit) && explicitProductLimit > 0) return explicitProductLimit;
        return productCountMql.matches ? MAX_VISIBLE_PRODUCTS_MOBILE : MAX_VISIBLE_PRODUCTS_DESKTOP;
      }

      function sizeProductList(root) {
        var list = root.querySelector('.ac-ProductList');
        var productsCol = root.querySelector('.ac-Layout__Products');
        var groupsCol = root.querySelector('.ac-Layout__Groups');

        if (productsCol) productsCol.style.minHeight = '';
        if (groupsCol) {
          groupsCol.style.maxHeight = '';
          groupsCol.style.overflowY = '';
        }

        if (!list || !list.children.length) {
          if (productsCol && groupsCol) {
            groupsCol.style.maxHeight = '';
            groupsCol.style.overflowY = '';
            var groupsNaturalHeight = groupsCol.getBoundingClientRect().height;
            productsCol.style.minHeight = groupsNaturalHeight + 'px';
          }
          syncGroupsHeight(root);
          return;
        }

        var items = list.children;
        var maxVisible = getMaxVisibleProducts();

        groupsNaturalHeight = groupsCol ? groupsCol.getBoundingClientRect().height : 0;

        if (items.length >= maxVisible) {
          var lastVisibleItem = items[maxVisible - 1];
          var listTop = list.getBoundingClientRect().top;
          var cutoff = lastVisibleItem.getBoundingClientRect().bottom - listTop;
          list.style.maxHeight = cutoff + 'px';
          list.style.overflowY = 'auto';
          if (productsCol) productsCol.style.minHeight = '';
        } else {
          var targetHeight = Math.max(502, groupsNaturalHeight);
          list.style.maxHeight = '';
          list.style.overflowY = 'hidden';
          if (productsCol) productsCol.style.minHeight = targetHeight + 'px';
        }
        syncGroupsHeight(root);
      }

      function syncGroupsHeight(root) {
        if (mobileMql.matches) return;
        var groups = root.querySelector('.ac-Layout__Groups');
        var productsCol = root.querySelector('.ac-Layout__Products');
        if (!groups || !productsCol) return;
        groups.style.maxHeight = '';
        var cap = productsCol.getBoundingClientRect().height;
        groups.style.maxHeight = cap + 'px';
        groups.style.overflowY = 'auto';
      }

      window.addEventListener('resize', function () {
        if (lastProductsRoot) sizeProductList(lastProductsRoot);
      });

      function makeAlgoliaSource(
        sourceId,
        indexName,
        hitsPerPage,
        attributesToRetrieve,
        filters,
        urlBuilder,
        extraParams,
        requestId,
      ) {
        return {
          sourceId: sourceId,
          getItems: function () {
            return searchClient
              .search([
                {
                  indexName: indexName,
                  query: currentQuery,
                  params: Object.assign(
                    {
                      hitsPerPage: hitsPerPage,
                      attributesToRetrieve: attributesToRetrieve,
                      filters: filters || undefined,
                    },
                    extraParams || {},
                  ),
                },
              ])
              .then(function (res) {
                var r = res.results[0];
                if (requestId === latestRequestId) {
                  cachedHits[sourceId] = r.hits;
                  cachedCounts[sourceId] = r.nbHits;
                  pendingSourceCount -= 1;
                  if (pendingSourceCount <= 0) finishRequest(requestId);
                }
                return requestId === latestRequestId ? r.hits : [];
              })
              .catch(function (err) {
                console.error('[Algolia] "' + sourceId + '" (' + indexName + ') search failed:', err);
                if (requestId === latestRequestId) {
                  cachedHits[sourceId] = [];
                  cachedCounts[sourceId] = 0;
                  pendingSourceCount -= 1;
                  if (pendingSourceCount <= 0) finishRequest(requestId);
                }
                return [];
              });
          },
          getItemUrl: function (_a) {
            var item = _a.item;
            return urlBuilder ? urlBuilder(item) : '#';
          },
          templates: {
            item: function () {
              return '';
            },
          },
        };
      }

      let searchQuery = new URLSearchParams(window.location.search).get('q');

      autocompleteFn({
        container: container,
        placeholder: container.getAttribute('data-placeholder') || 'Search',
        openOnFocus: true,
        detachedMediaQuery: 'none',
        initialState: { query: searchQuery || '' },
        panelContainer: container,
        shouldPanelOpen: function () {
          return activeContainer === container;
        },
        onFocus: function (_a) {
          syncPanelLeft();
          _a.setIsOpen(true);
        },
        onSubmit: function (_a) {
          var state = _a.state;
          if (state.query) {
            saveRecentSearch(state.query);
            window.location.href = '/search?q=' + encodeURIComponent(state.query);
          }
        },
        onStateChange: function (_a) {
          var state = _a.state;
          if (state.status === 'idle' && !state.query) {
            cachedHits = {};
            cachedCounts = {};
          }
        },
        getSources: function (_a) {
          var q = _a.query;

          if (!q || q.trim().length === 2) {
            return [
              {
                sourceId: 'default-state',
                getItems: function () {
                  return [];
                },
                templates: {
                  item: function () {
                    return '';
                  },
                  empty: function () {
                    return '';
                  },
                },
              },
            ];
          }

          if (q.trim().length < 3) {
            return [
              {
                sourceId: 'default-state',
                getItems: function () {
                  return [];
                },
                templates: {
                  item: function () {
                    return '';
                  },
                  empty: function () {
                    return '';
                  },
                },
              },
            ];
          }

          // Traced against the real library: onStateChange/render is only
          // invoked again once every source's promise settles — there is no
          // automatic re-render for the window between "query changed" and
          // "response arrived". Left alone, the panel just sits frozen on
          // whatever was on screen a keystroke ago for that whole window.
          // So a genuinely new query (not e.g. a refocus re-invoking
          // getSources for the same text) has to force its own immediate
          // skeleton paint here, synchronously, rather than wait to be
          // rendered.
          var isNewQuery = q !== currentQuery;
          currentQuery = q;

          if (isNewQuery) {
            latestRequestId += 1;
            pendingSourceCount = 6;
            requestStartedAt = Date.now();
            cachedHits = {};
            cachedCounts = {};
            resolvedRequestId = -1;
            isLoading = true;
            lastPaintedState = { query: q };
            if (lastPaintedRoot) renderPanel(lastPaintedState, lastPaintedRoot);
          }
          var thisRequestId = latestRequestId;

          var sources = [
            makeAlgoliaSource(
              'suggestions',
              config.indices.queryContent,
              5,
              ['query'],
              undefined,
              function (item) {
                return '/search?q=' + encodeURIComponent(item.query || item.objectID || '');
              },
              undefined,
              thisRequestId,
            ),
            makeAlgoliaSource(
              'products',
              config.indices.products,

              getMaxVisibleProducts(),
              [
                'title',
                'handle',
                'url',
                'image',
                'price',
                'compare_at_price',
                'variants_count',
                'variants_min_price',
                'variants_compare_at_price_max',
              ],
              undefined,
              function (item) {
                return item.url || '/products/' + item.handle;
              },

              { distinct: 1 },
              thisRequestId,
            ),
            makeAlgoliaSource(
              'collections',
              config.indices.collections,
              5,
              ['title', 'handle', 'products_count'],
              undefined,
              function (item) {
                return '/collections/' + item.handle;
              },
              undefined,
              thisRequestId,
            ),
            makeAlgoliaSource(
              'recipes',
              config.indices.articles,
              5,
              ['title', 'handle', 'blog'],
              'blog.handle:"recipe"',
              function (item) {
                return '/blogs/recipe/' + item.handle;
              },
              undefined,
              thisRequestId,
            ),
            makeAlgoliaSource(
              'blogs',
              config.indices.articles,
              5,
              ['title', 'handle', 'blog'],
              'NOT blog.handle:"recipe"',
              function (item) {
                var blogHandle = (item.blog && item.blog.handle) || 'article';
                return '/blogs/' + blogHandle + '/' + item.handle;
              },
              undefined,
              thisRequestId,
            ),
            makeAlgoliaSource(
              'pages',
              config.indices.pages,
              5,
              ['title', 'handle'],
              undefined,
              function (item) {
                return '/pages/' + item.handle;
              },
              undefined,
              thisRequestId,
            ),
          ];

          return sources;
        },

        render: function (_a, root) {
          var state = _a.state;
          lastPaintedState = state;
          lastPaintedRoot = root;
          renderPanel(state, root);
        },
      });

      function renderPanel(state, root) {
        var isMobile =
          container.getAttribute('data-mobile') === 'true' || container.getAttribute('data-layout') === 'mobile';
        var isNarrow = !state.query || state.query.trim().length < 3;
        root.classList.toggle('ac-Panel--narrow', isNarrow);

        if (!state.query || state.query.trim().length === 0) {
          root.innerHTML = renderDefaultState();
          bindDefaultStateEvents(root);
          return;
        }

        if (state.query.trim().length < 3) {
          root.innerHTML = renderDefaultState();
          bindDefaultStateEvents(root);
          return;
        }

        if (resolvedRequestId !== latestRequestId) {
          root.innerHTML = renderSkeletonState(isMobile);
          return;
        }

        var suggestions = cachedHits.suggestions || [];
        var products = cachedHits.products || [];
        var collections = cachedHits.collections || [];
        var recipes = cachedHits.recipes || [];
        var blogs = cachedHits.blogs || [];
        var pages = cachedHits.pages || [];
        var productCount = cachedCounts.products || 0;

        var hasSuggestions = suggestions.length > 0;
        var hasCollections = collections.length > 0;
        var hasRecipes = recipes.length > 0;
        var hasBlogs = blogs.length > 0;
        var hasPages = pages.length > 0;
        var hasProducts = products.length > 0;

        if (!hasSuggestions && !hasCollections && !hasRecipes && !hasBlogs && !hasPages && !hasProducts) {
          if (isLoading) {
            root.innerHTML = renderSkeletonState(isMobile);
            return;
          }
          root.innerHTML =
            '<div class="ac-NoResults"><p>No results found for "' +
            escapeHtml(state.query) +
            '"</p><a class="ac-NoResults__SeeAll" href="/collections/all">See all products</a></div>';
          return;
        }

        var html = '';

        if (isMobile) {
          html += '<div class="ac-MobileResults" role="listbox">';

          if (hasSuggestions) {
            html += '<div class="ac-Group">';
            html += '<h3 class="ac-Group__Heading">Suggestions</h3>';
            html += '<ul class="ac-List">';
            suggestions.forEach(function (item) {
              var q = item.query || item.objectID || '';
              html +=
                '<li class="ac-List__Item" role="option" aria-selected="false">' +
                '<a class="ac-List__Link" href="/search?q=' +
                encodeURIComponent(q) +
                '">' +
                SVG_SEARCH +
                '<span>' +
                escapeHtml(q) +
                '</span>' +
                '</a>' +
                SVG_ARROW +
                '</li>';
            });
            html += '</ul></div>';
          }

          if (hasProducts) {
            html += '<hr class="ac-Divider">';
            html += '<div class="ac-Group">';
            html += '<div class="ac-ProductsHeader">';
            html += '<h3 class="ac-Group__Heading ac-Group__Heading--dark">Products</h3>';
            html +=
              '<a class="ac-ViewAll" href="/search?q=' +
              encodeURIComponent(state.query) +
              '">View all <span>' +
              productCount +
              '</span> results</a>';
            html += '</div>';
            html += '<ul class="ac-MobileProductGrid">';
            products.forEach(function (item) {
              var img = item.image || '';
              var minPrice = item.variants_min_price || item.price;
              var compareAtMax = item.variants_compare_at_price_max || item.compare_at_price;
              var isMultiVariant = (item.variants_count || 1) > 1;
              var isOnSale = compareAtMax && compareAtMax > 0 && minPrice < compareAtMax;
              var link = item.url || '/products/' + item.handle;
              var priceHtml = '';
              if (isOnSale) {
                priceHtml =
                  '<span class="ac-Price--sale">' +
                  (isMultiVariant ? 'From ' : '') +
                  formatPrice(minPrice) +
                  '</span>' +
                  '<s class="ac-Price--compare">' +
                  formatPrice(compareAtMax) +
                  '</s>';
              } else if (isMultiVariant && minPrice) {
                priceHtml = '<span class="ac-Price">From ' + formatPrice(minPrice) + '</span>';
              } else if (minPrice) {
                priceHtml = '<span class="ac-Price">' + formatPrice(minPrice) + '</span>';
              }
              html +=
                '<li class="ac-MobileProductCard" role="option" aria-selected="false">' +
                '<a class="ac-MobileProductCard__Link" href="' +
                escapeHtml(link) +
                '">' +
                '<div class="ac-MobileProductCard__Image">' +
                '<img src="' +
                escapeHtml(img || PLACEHOLDER_IMAGE) +
                '" alt="" loading="lazy">' +
                '</div>' +
                '<div class="ac-MobileProductCard__Body">' +
                '<span class="ac-ProductItem__Title">' +
                escapeHtml(item.title || '') +
                '</span>' +
                '<span class="ac-ProductItem__Price">' +
                priceHtml +
                '</span>' +
                '</div></a></li>';
            });
            html += '</ul></div>';
          }

          if (hasCollections) {
            html += '<hr class="ac-Divider">';
            html += '<div class="ac-Group">';
            html += '<h3 class="ac-Group__Heading">Collections</h3>';
            html += '<ul class="ac-List">';
            collections.forEach(function (item) {
              var link = '/collections/' + item.handle;
              var count = item.products_count;
              html +=
                '<li class="ac-List__Item" role="option" aria-selected="false">' +
                '<a class="ac-List__Link ac-List__Link--plain" href="' +
                escapeHtml(link) +
                '">' +
                '<span>' +
                escapeHtml(item.title) +
                '</span>' +
                (count ? '<span class="ac-List__Count">' + count + ' items</span>' : '') +
                '</a></li>';
            });
            html += '</ul></div>';
          }

          if (hasRecipes) {
            html += '<hr class="ac-Divider">';
            html += '<div class="ac-Group">';
            html += '<h3 class="ac-Group__Heading">Recipes</h3>';
            html += '<ul class="ac-List">';
            recipes.forEach(function (item) {
              var link = '/blogs/recipe/' + item.handle;
              html +=
                '<li class="ac-List__Item" role="option" aria-selected="false">' +
                '<a class="ac-List__Link ac-List__Link--plain" href="' +
                escapeHtml(link) +
                '">' +
                '<span>' +
                escapeHtml(item.title) +
                '</span>' +
                '</a></li>';
            });
            html += '</ul></div>';
          }

          if (hasBlogs) {
            html += '<hr class="ac-Divider">';
            html += '<div class="ac-Group">';
            html += '<h3 class="ac-Group__Heading">Blogs</h3>';
            html += '<ul class="ac-List">';
            blogs.forEach(function (item) {
              var blogHandle = (item.blog && item.blog.handle) || 'article';
              var link = '/blogs/' + blogHandle + '/' + item.handle;
              html +=
                '<li class="ac-List__Item" role="option" aria-selected="false">' +
                '<a class="ac-List__Link ac-List__Link--plain" href="' +
                escapeHtml(link) +
                '">' +
                '<span>' +
                escapeHtml(item.title) +
                '</span>' +
                '</a></li>';
            });
            html += '</ul></div>';
          }

          if (hasPages) {
            html += '<hr class="ac-Divider">';
            html += '<div class="ac-Group">';
            html += '<h3 class="ac-Group__Heading">Pages</h3>';
            html += '<ul class="ac-List">';
            pages.forEach(function (item) {
              var link = '/pages/' + item.handle;
              html +=
                '<li class="ac-List__Item" role="option" aria-selected="false">' +
                '<a class="ac-List__Link ac-List__Link--plain" href="' +
                escapeHtml(link) +
                '">' +
                '<span>' +
                escapeHtml(item.title) +
                '</span>' +
                '</a></li>';
            });
            html += '</ul></div>';
          }

          html += '</div>';
        } else {
          // Desktop: existing two-column layout — keep exactly as before
          html += '<div class="ac-Layout">';
          html += '<div class="ac-Layout__Groups">';
          var groupRendered = false;

          if (hasSuggestions) {
            groupRendered = true;
            html += '<div class="ac-Group">';
            html += '<h3 class="ac-Group__Heading">Suggestions</h3>';
            html += '<ul class="ac-List">';
            suggestions.forEach(function (item) {
              var q = item.query || item.objectID || '';
              html +=
                '<li class="ac-List__Item" aria-selected="false">' +
                '<a class="ac-List__Link" href="/search?q=' +
                encodeURIComponent(q) +
                '">' +
                SVG_SEARCH +
                '<span>' +
                escapeHtml(q) +
                '</span>' +
                '</a>' +
                SVG_ARROW +
                '</li>';
            });
            html += '</ul></div>';
          }

          if (hasCollections) {
            if (groupRendered) html += '<hr class="ac-Divider">';
            groupRendered = true;
            html += '<div class="ac-Group">';
            html += '<h3 class="ac-Group__Heading">Collections</h3>';
            html += '<ul class="ac-List">';
            collections.forEach(function (item) {
              var link = '/collections/' + item.handle;
              var count = item.products_count;
              html +=
                '<li class="ac-List__Item" aria-selected="false">' +
                '<a class="ac-List__Link ac-List__Link--plain" href="' +
                escapeHtml(link) +
                '">' +
                '<span>' +
                escapeHtml(item.title) +
                '</span>' +
                (count ? '<span class="ac-List__Count">' + count + ' items</span>' : '') +
                '</a></li>';
            });
            html += '</ul></div>';
          }

          if (hasRecipes) {
            if (groupRendered) html += '<hr class="ac-Divider">';
            groupRendered = true;
            html += '<div class="ac-Group">';
            html += '<h3 class="ac-Group__Heading">Recipes</h3>';
            html += '<ul class="ac-List">';
            recipes.forEach(function (item) {
              var link = '/blogs/recipe/' + item.handle;
              html +=
                '<li class="ac-List__Item" aria-selected="false">' +
                '<a class="ac-List__Link ac-List__Link--plain" href="' +
                escapeHtml(link) +
                '">' +
                '<span>' +
                escapeHtml(item.title) +
                '</span>' +
                '</a></li>';
            });
            html += '</ul></div>';
          }

          if (hasBlogs) {
            if (groupRendered) html += '<hr class="ac-Divider">';
            groupRendered = true;
            html += '<div class="ac-Group">';
            html += '<h3 class="ac-Group__Heading">Blogs</h3>';
            html += '<ul class="ac-List">';
            blogs.forEach(function (item) {
              var blogHandle = (item.blog && item.blog.handle) || 'article';
              var link = '/blogs/' + blogHandle + '/' + item.handle;
              html +=
                '<li class="ac-List__Item" aria-selected="false">' +
                '<a class="ac-List__Link ac-List__Link--plain" href="' +
                escapeHtml(link) +
                '">' +
                '<span>' +
                escapeHtml(item.title) +
                '</span>' +
                '</a></li>';
            });
            html += '</ul></div>';
          }

          if (hasPages) {
            if (groupRendered) html += '<hr class="ac-Divider">';
            html += '<div class="ac-Group">';
            html += '<h3 class="ac-Group__Heading">Pages</h3>';
            html += '<ul class="ac-List">';
            pages.forEach(function (item) {
              var link = '/pages/' + item.handle;
              html +=
                '<li class="ac-List__Item" aria-selected="false">' +
                '<a class="ac-List__Link ac-List__Link--plain" href="' +
                escapeHtml(link) +
                '">' +
                '<span>' +
                escapeHtml(item.title) +
                '</span>' +
                '</a></li>';
            });
            html += '</ul></div>';
          }

          html += '</div>';

          if (hasProducts || groupRendered) {
            html += '<div class="ac-Layout__Products">';
            html += '<div class="ac-ProductsHeader">';
            html += '<h3 class="ac-Group__Heading ac-Group__Heading--dark">Products</h3>';
            if (hasProducts) {
              html += '<a class="ac-ViewAll" href="/search?q=' + encodeURIComponent(state.query) + '">';
              html += 'View all <span>' + productCount + '</span> results</a>';
            }
            html += '</div>';
          }

          if (hasProducts) {
            html += '<ul class="ac-ProductList">';
            products.forEach(function (item) {
              var img = item.image || '';
              // variants_min_price/variants_compare_at_price_max reflect the whole
              // product; price/compare_at_price are just the matched variant's own
              // values, so prefer the former (matches the /search results page).
              var minPrice = item.variants_min_price || item.price;
              var compareAtMax = item.variants_compare_at_price_max || item.compare_at_price;
              var isMultiVariant = (item.variants_count || 1) > 1;
              var isOnSale = compareAtMax && compareAtMax > 0 && minPrice < compareAtMax;
              var link = item.url || '/products/' + item.handle;
              var priceHtml = '';
              if (isOnSale) {
                priceHtml =
                  '<span class="ac-Price--sale">' +
                  (isMultiVariant ? 'From ' : '') +
                  formatPrice(minPrice) +
                  '</span>' +
                  '<s class="ac-Price--compare">' +
                  formatPrice(compareAtMax) +
                  '</s>';
              } else if (isMultiVariant && minPrice) {
                priceHtml = '<span class="ac-Price">From ' + formatPrice(minPrice) + '</span>';
              } else if (minPrice) {
                priceHtml = '<span class="ac-Price">' + formatPrice(minPrice) + '</span>';
              }
              html +=
                '<li class="ac-ProductItem" aria-selected="false">' +
                '<a class="ac-ProductItem__Link" href="' +
                escapeHtml(link) +
                '">' +
                '<div class="ac-ProductItem__Image">' +
                '<img src="' +
                escapeHtml(img || PLACEHOLDER_IMAGE) +
                '" alt="" loading="lazy" width="103" height="103">' +
                '</div>' +
                '<div class="ac-ProductItem__Body">' +
                '<span class="ac-ProductItem__Title">' +
                escapeHtml(item.title || '') +
                '</span>' +
                '<span class="ac-ProductItem__Price">' +
                priceHtml +
                '</span>' +
                '</div></a></li>';
            });
            html += '</ul>';
          } else if (groupRendered) {
            html +=
              '<div class="ac-NoResults ac-NoResults--products"><p>No results found for "' +
              escapeHtml(state.query) +
              '"</p><a class="ac-NoResults__SeeAll" href="/search?q=' +
              encodeURIComponent(state.query) +
              '&tab=products">View all products</a></div>';
          }

          if (hasProducts || groupRendered) {
            html += '</div>';
          }

          html += '</div>';
        }

        root.innerHTML = html;

        if (!isMobile && (hasProducts || groupRendered)) {
          lastProductsRoot = root;
          sizeProductList(root);
        }

        var totalCount = suggestions.length + collections.length + recipes.length + blogs.length + pages.length;
        var announcement =
          productCount > 0
            ? totalCount + ' suggestions and ' + productCount + ' products found for ' + state.query
            : totalCount > 0
              ? totalCount + ' results found for ' + state.query
              : 'No results found for ' + state.query;
        liveRegion.textContent = announcement;
      }

      var isClosingSearch = false;

      container.addEventListener(
        'focus',
        function (e) {
          if (e.target.classList && e.target.classList.contains('aa-Input')) {
            // Don't re-open search if we're in the middle of closing it
            if (!isClosingSearch) {
              openSearch(container);
            }
          }
        },
        true,
      );

      // Must run in the capture phase, ahead of the real Algolia
      // Autocomplete library's own click handler on .aa-ClearButton (bound
      // directly to that button when the library renders it). The library's
      // own reset behavior calls the input's focus() internally, which
      // re-enters openSearch() via the capturing 'focus' listener above —
      // before our own bubble-phase clear handler further down ever gets a
      // chance to set the guard. Setting it here, during capture, closes
      // that race regardless of whether the refocus comes from the library
      // itself or from our own code later in the flow.
      // Armed in the capture phase, on the earliest possible event
      // (mousedown, ahead of click), so it's set before the real Autocomplete
      // library's own handler on .aa-ClearButton — whatever event it's bound
      // to and whatever refocus mechanism it uses internally — has any
      // chance to run. Capture-phase listeners on an ancestor always run
      // before listeners on the target itself.
      container.addEventListener(
        'mousedown',
        function (e) {
          if (e.target.closest && e.target.closest('.aa-ClearButton')) {
            armSuppressNextOpenAnalytics();
          }
        },
        true,
      );

      container.addEventListener(
        'click',
        function (e) {
          if (e.target.closest && e.target.closest('.aa-ClearButton')) {
            armSuppressNextOpenAnalytics();
          }
        },
        true,
      );

      container.addEventListener('focusout', function (e) {
        var isMobile =
          container.getAttribute('data-mobile') === 'true' || container.getAttribute('data-layout') === 'mobile';
        if (isMobile) return;
        var nextFocus = e.relatedTarget;
        if (nextFocus && container.contains(nextFocus)) return;
        setTimeout(function () {
          if (container.contains(document.activeElement)) return;
          var inp = container.querySelector('.aa-Input');
          if (inp) {
            if (!isPathSearch) {
              inp.value = '';
            }
            inp.dispatchEvent(new Event('input', { bubbles: true }));
          }
          closeSearch();
        }, 80);
      });

      container.addEventListener(
        'keydown',
        function (e) {
          if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Enter') return;

          var input = container.querySelector('.aa-Input');
          if (e.target !== input) return;

          var panel = container.querySelector('.aa-Panel');
          if (!panel) return;
          var items = Array.prototype.slice.call(
            panel.querySelectorAll('.ac-List__Item, .ac-ProductItem, .ac-MobileProductCard, .ac-Chip__Item'),
          );
          if (!items.length) return;

          var currentIdx = items.findIndex(function (item) {
            return item.getAttribute('aria-selected') === 'true';
          });

          if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();
            e.stopPropagation();
            var nextIdx;
            if (currentIdx === -1) {
              nextIdx = e.key === 'ArrowDown' ? 0 : items.length - 1;
            } else if (e.key === 'ArrowDown') {
              nextIdx = Math.min(currentIdx + 1, items.length - 1);
            } else {
              nextIdx = Math.max(currentIdx - 1, 0);
            }
            items.forEach(function (item, i) {
              item.setAttribute('aria-selected', i === nextIdx ? 'true' : 'false');
            });
            items[nextIdx].scrollIntoView({ block: 'nearest' });
          } else if (e.key === 'Enter' && currentIdx > -1) {
            var link = items[currentIdx].querySelector('a[href]');
            if (link) {
              e.preventDefault();
              e.stopPropagation();
              if (input.value.trim()) saveRecentSearch(input.value.trim());
              window.location.href = link.href;
            }
          }
        },
        true,
      );

      container.addEventListener('click', function (e) {
        var formEl = e.target.closest && e.target.closest('.aa-Form');
        if (
          formEl &&
          !e.target.closest('.aa-SubmitButton') &&
          !e.target.closest('.aa-ClearButton') &&
          !e.target.closest('.aa-Input')
        ) {
          var formInput = formEl.querySelector('.aa-Input');
          if (formInput && document.activeElement !== formInput) formInput.focus();
        }

        var resultLink =
          e.target.closest &&
          (e.target.closest('.ac-List__Link') ||
            e.target.closest('.ac-MobileProductCard__Link') ||
            e.target.closest('.ac-ProductItem__Link'));
        if (resultLink) {
          // Determine content type and extract data
          var linkHref = resultLink.getAttribute('href');
          var linkTitle = '';
          var moduleName = 'navigation:searchBar:autocomplete';

          // Product click
          if (
            resultLink.classList.contains('ac-ProductItem__Link') ||
            resultLink.classList.contains('ac-MobileProductCard__Link')
          ) {
            var titleEl = resultLink.querySelector('.ac-ProductItem__Title');
            linkTitle = titleEl ? titleEl.textContent.trim() : '';
            moduleName = 'navigation:searchBar:autocomplete:product';
          }
          // Query suggestion click
          else if (resultLink.classList.contains('ac-List__Link')) {
            var parentGroup = resultLink.closest('.ac-Group');
            var groupHeading = parentGroup ? parentGroup.querySelector('.ac-Group__Heading') : null;
            var headingText = groupHeading ? groupHeading.textContent.trim() : '';

            if (headingText === 'Suggestions') {
              var suggestionText = resultLink.querySelector('span');
              linkTitle = suggestionText ? suggestionText.textContent.trim() : '';
              moduleName = 'navigation:searchBar:autocomplete:querySuggestion';
            }
            // Collection click
            else if (linkHref && linkHref.includes('/collections/')) {
              var collectionTitle = resultLink.querySelector('span');
              linkTitle = collectionTitle ? collectionTitle.textContent.trim() : '';
              moduleName = 'navigation:searchBar:autocomplete:collection';
            }
            // Recipe click
            else if (linkHref && linkHref.includes('/blogs/recipe/')) {
              var recipeTitle = resultLink.querySelector('span');
              linkTitle = recipeTitle ? recipeTitle.textContent.trim() : '';
              moduleName = 'navigation:searchBar:autocomplete:recipe';
            }
            // Blog click (non-recipe)
            else if (linkHref && linkHref.includes('/blogs/') && !linkHref.includes('/blogs/recipe/')) {
              var blogTitle = resultLink.querySelector('span');
              linkTitle = blogTitle ? blogTitle.textContent.trim() : '';
              moduleName = 'navigation:searchBar:autocomplete:blog';
            }
            // Page click
            else if (linkHref && linkHref.includes('/pages/')) {
              var pageTitle = resultLink.querySelector('span');
              linkTitle = pageTitle ? pageTitle.textContent.trim() : '';
              moduleName = 'navigation:searchBar:autocomplete:page';
            }
          }

          // Publish click event (P0)
          publishClickEvent(moduleName, linkTitle, 'link', linkHref);

          var inp = container.querySelector('.aa-Input');
          if (inp && inp.value.trim()) {
            saveRecentSearch(inp.value.trim());
          }
        }
        var submitBtn = e.target.closest && e.target.closest('.aa-SubmitButton');
        if (submitBtn) {
          e.preventDefault();
          var inputToFocus = container.querySelector('.aa-Input');
          if (inputToFocus && inputToFocus.value.trim()) {
            // Publish searchSubmit event (P0)
            publishClickEvent('navigation:searchBar', 'searchSubmit', 'searchSubmit', null);

            saveRecentSearch(inputToFocus.value.trim());
            window.location.href = '/search?q=' + encodeURIComponent(inputToFocus.value.trim());
            return;
          }
          if (inputToFocus) inputToFocus.focus();
          return;
        }

        var clearBtn = e.target.closest && e.target.closest('.aa-ClearButton');
        if (clearBtn) {
          e.preventDefault();
          e.stopPropagation();

          // Publish searchClear event (P0)
          publishClickEvent('navigation:searchBar', 'searchClear', 'searchClear', null);

          // Belt-and-suspenders: the capturing mousedown/click listeners
          // above already arm this before we get here, but re-arming keeps
          // the window open for the isMobile branch below regardless of
          // exactly when the library's own internal refocus lands.
          armSuppressNextOpenAnalytics();

          var isMobile = container.getAttribute('data-mobile') === 'true';
          inp = container.querySelector('.aa-Input');
          if (inp) {
            inp.value = '';
            inp.dispatchEvent(new Event('input', { bubbles: true }));
            if (isMobile) {
              // Focus input on mobile to keep search open
              setTimeout(function () {
                inp.focus();
              }, 50);
            } else {
              // On desktop, blur and close without re-opening
              isClosingSearch = true;
              inp.blur();
              if (document.activeElement) document.activeElement.blur();
              // Suppress searchClose analytics since searchClear already published
              closeSearch(true);
              setTimeout(function () {
                isClosingSearch = false;
              }, 100);
            }
          }
        }
      });

      if (window.visualViewport) {
        function onViewportResize() {
          var isMobile = container.getAttribute('data-mobile') === 'true';
          if (!isMobile) return;
          var activeInput = container.querySelector('.aa-Input');
          if (activeInput && document.activeElement === activeInput) {
            setTimeout(function () {
              activeInput.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
            }, 100);
          }
        }
        window.visualViewport.addEventListener('resize', onViewportResize);
      }
    });

    if (mobileSearchTrigger && mobileOverlay) {
      mobileSearchTrigger.addEventListener('click', function () {
        mobileOverlay.hidden = false;
        mobileSearchTrigger.setAttribute('aria-expanded', 'true');
        document.body.classList.add('ac-overflow-hidden');
        document.body.style.overscrollBehavior = 'none';
        var mobileInput = mobileOverlay.querySelector('.aa-Input');
        if (mobileInput) {
          mobileInput.setAttribute('role', 'combobox');
          mobileInput.setAttribute('aria-expanded', 'true');
          setTimeout(function () {
            mobileInput.focus();
            mobileInput.dispatchEvent(new Event('input', { bubbles: true }));
          }, 50);
        }
      });

      var mobileCloseBtn = mobileOverlay.querySelector('.ac-MobileOverlay__Close');
      if (mobileCloseBtn) {
        mobileCloseBtn.addEventListener('click', function () {
          closeSearch();
        });
      }

      function isVisible(el) {
        return !!el && el.offsetParent !== null;
      }

      function getMobileTabStops() {
        return [
          mobileOverlay.querySelector('.aa-Input'),
          mobileOverlay.querySelector('.aa-ClearButton'),
          mobileOverlay.querySelector('.ac-MobileOverlay__Close'),
        ].filter(isVisible);
      }

      mobileOverlay.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' || mobileOverlay.hidden) return;
        var stops = getMobileTabStops();
        if (!stops.length) return;
        var idx = stops.indexOf(document.activeElement);
        e.preventDefault();
        var nextIdx;
        if (e.shiftKey) {
          nextIdx = idx <= 0 ? stops.length - 1 : idx - 1;
        } else {
          nextIdx = idx === -1 || idx === stops.length - 1 ? 0 : idx + 1;
        }
        stops[nextIdx].focus();
      });
    }
  }

  function renderDefaultState() {
    var recent = getRecentSearches();
    var html = '<div class="ac-Default" role="listbox">';

    html += '<div class="ac-Group">';
    html += '<h3 class="ac-Group__Heading">Recent searches</h3>';
    if (recent.length > 0) {
      html += '<ul class="ac-List">';
      recent.forEach(function (term) {
        html +=
          '<li class="ac-List__Item" role="option" aria-selected="false">' +
          '<a class="ac-List__Link" href="/search?q=' +
          encodeURIComponent(term) +
          '">' +
          SVG_CLOCK +
          '<span>' +
          escapeHtml(term) +
          '</span>' +
          '</a>' +
          '<button class="ac-RemoveRecent" data-remove="' +
          escapeHtml(term) +
          '" aria-label="Remove ' +
          escapeHtml(term) +
          ' from recent searches">' +
          SVG_CLOSE +
          '</button>' +
          '</li>';
      });
      html += '</ul>';
    } else {
      html += '<p class="ac-EmptyHint">No recent searches</p>';
    }
    html += '</div>';

    html += '<hr class="ac-Divider">';

    html += '<div class="ac-Group">';
    html += '<h3 class="ac-Group__Heading">Most popular searches</h3>';
    html += '<ul class="ac-ChipList">';
    POPULAR_SEARCHES.forEach(function (term) {
      html +=
        '<li class="ac-Chip__Item" role="option" aria-selected="false"><a class="ac-Chip" href="/search?q=' +
        encodeURIComponent(term) +
        '">' +
        SVG_TRENDING +
        escapeHtml(term) +
        '</a></li>';
    });
    html += '</ul>';
    html += '</div>';

    html += '</div>';
    return html;
  }

  function renderSkeletonState(isMobile) {
    if (isMobile) {
      var html = '<div class="ac-MobileResults">';
      html += '<div class="ac-Group">';
      html += '<h3 class="ac-Group__Heading">Suggestions</h3>';
      html += '<ul class="ac-List" aria-hidden="true">';
      for (var i = 0; i < 3; i++) {
        html += '<li class="ac-List__Item"><div class="ac-Skeleton ac-Skeleton--text">&#8203;</div></li>';
      }
      html += '</ul></div>';
      html += '<hr class="ac-Divider">';
      html += '<div class="ac-Group">';
      html += '<h3 class="ac-Group__Heading ac-Group__Heading--dark">Products</h3>';
      html += '<ul class="ac-MobileProductGrid" aria-hidden="true">';
      var skeletonProductCount = window.matchMedia('(max-width: 767px)').matches ? 4 : 5;
      for (var j = 0; j < skeletonProductCount; j++) {
        html +=
          '<li class="ac-MobileProductCard">' +
          '<div class="ac-MobileProductCard__Link">' +
          '<div class="ac-MobileProductCard__Image ac-Skeleton ac-Skeleton--image">&#8203;</div>' +
          '<div class="ac-MobileProductCard__Body">' +
          '<div class="ac-Skeleton ac-Skeleton--title">&#8203;</div>' +
          '<div class="ac-Skeleton ac-Skeleton--price">&#8203;</div>' +
          '</div></div></li>';
      }
      html += '</ul></div>';
      html += '</div>';
      return html;
    }

    html = '<div class="ac-Layout">';
    html += '<div class="ac-Layout__Groups">';
    html += '<div class="ac-Group">';
    html += '<h3 class="ac-Group__Heading">Recent searches</h3>';
    html += '<ul class="ac-List" aria-hidden="true">';
    for (var k = 0; k < 3; k++) {
      html += '<li class="ac-List__Item"><div class="ac-Skeleton ac-Skeleton--text">&#8203;</div></li>';
    }
    html += '</ul></div></div>';

    html += '<div class="ac-Layout__Products">';
    html += '<div class="ac-ProductsHeader">';
    html += '<h3 class="ac-Group__Heading ac-Group__Heading--dark">Products</h3>';
    html += '</div>';
    html += '<ul class="ac-ProductList" aria-hidden="true">';
    for (var l = 0; l < 5; l++) {
      html +=
        '<li class="ac-ProductItem">' +
        '<div class="ac-ProductItem__Link">' +
        '<div class="ac-ProductItem__Image ac-Skeleton ac-Skeleton--image">&#8203;</div>' +
        '<div class="ac-ProductItem__Body">' +
        '<div class="ac-Skeleton ac-Skeleton--title">&#8203;</div>' +
        '<div class="ac-Skeleton ac-Skeleton--price">&#8203;</div>' +
        '</div></div></li>';
    }
    html += '</ul></div>';
    html += '</div>';
    return html;
  }

  function bindDefaultStateEvents(root) {
    // Recent search click tracking
    root.querySelectorAll('.ac-List__Link').forEach(function (link) {
      if (link.closest('.ac-List__Item')) {
        link.addEventListener('click', function () {
          var searchTerm = this.querySelector('span');
          var termText = searchTerm ? searchTerm.textContent.trim() : '';

          // Publish recentSearch click event (P1)
          publishClickEvent(
            'navigation:searchBar:autocomplete:recentSearch',
            termText,
            'link',
            this.getAttribute('href'),
          );
        });
      }
    });

    // Popular search click tracking
    root.querySelectorAll('.ac-Chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var searchTerm = this.textContent.trim();
        // Remove the trending icon text if present
        searchTerm = searchTerm.replace(/^\s*/, '');

        // Publish popularSearch click event (P1)
        publishClickEvent(
          'navigation:searchBar:autocomplete:popularSearch',
          searchTerm,
          'link',
          this.getAttribute('href'),
        );
      });
    });

    // Recent search dismiss tracking
    root.querySelectorAll('[data-remove]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var term = btn.getAttribute('data-remove');

        // Publish recentSearch dismiss event (P1)
        publishClickEvent('navigation:searchBar:autocomplete:recentSearch', term, 'dismiss', null);

        removeRecentSearch(term);
        var item = btn.closest('.ac-List__Item');
        var list = item ? item.closest('.ac-List') : null;
        if (item) item.remove();
        if (list && !list.querySelector('.ac-List__Item')) {
          var hint = document.createElement('p');
          hint.className = 'ac-EmptyHint';
          hint.textContent = 'No recent searches';
          list.replaceWith(hint);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAutocomplete);
  } else {
    initAutocomplete();
  }
})();
